export enum ClientSearchModalType {
	CLIENT = "client",
	PET = "pet",
}
